import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import TextInput from 'components/form/TextInput';
import DatePicker from 'components/form/DatePicker';

const Guests = ({ question }) => {
  return (
    <>
      <Typography variant="subtitle1" fontWeight={500}>
        {question.question_label}
      </Typography>
      <Grid container spacing={2}>
        <Grid item md={4}>
          <TextInput placeholder="First Name" />
        </Grid>
        <Grid item md={4}>
          <TextInput placeholder="Last Name" />
        </Grid>
        <Grid item md={4}>
          <DatePicker placeholder="Date of Birth" />
        </Grid>
      </Grid>
      <TextInput
        fullWidth
        label="Special Instructions"
        placeholder="eg: needs supervision, is very shy, doesn’t do well in big crowds, etc."
      />
    </>
  );
};

export default Guests;
